<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'RessourcesEntete'
});
</script>
<template>
  <ka-container
    code="ressources-entete"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <ka-text
      code="lt-toutes-les-ressources"
      :options="{
        href: { name: `hub-expert-Ressources` },
        click: componentInstance.ltToutesLesRessourcesClick
      }"
      :xs="{ hidden: null }">
      <span v-html="t('ressourcesEntete.ltToutesLesRessources.value', `< Toutes les ressources`)" />
    </ka-text>
    <ka-text code="h-1">
      <h1 v-html="componentInstance.$title.value" />
      <template #xs>
        <h1 v-html="componentInstance.$title.value" />
      </template>
    </ka-text>
    <!-- Container -->
    <ka-container code="container" />
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { ressourcesEnteteComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c17')
const component = ressourcesEnteteComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  title?: Nullable<string>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  title: '',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:title'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: { title: true }
})
</script>
